import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import { routesWhiteList } from './setting.config'

NProgress.configure({
  easing: 'ease',
  speed: 500,
  trickleSpeed: 200,
  showSpinner: false,
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const accessToken = store.getters['user/accessToken']
  if (accessToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      return
    }
    store.dispatch('routes/initRoutes')
    next()
    return
  }

  // 判断当前路由是否在白名单中
  if (routesWhiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    // 无 accessToken , 进入登录页
    next({ path: '/login', query: { redirect: to.path } })
  }
})

router.beforeResolve((to, from, next) => {
  next()
  document.title = to?.meta?.title || process.env.VUE_APP_NAME
  NProgress.done()
})
